import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  registry: {},
  loading: false,
  saving: false,
  error: false
};

export default function schedule(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@schedule/INDEX_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@schedule/CREATE_REQUEST':
    case '@schedule/UPDATE_REQUEST':
    case '@schedule/DELETE_REQUEST':
      return produce(state, draft => {
        draft.saving = true;
        draft.error = false;
      });

    case '@schedule/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.registry = {};
      });

    case '@schedule/CREATE_SUCCESS':
    case '@schedule/UPDATE_SUCCESS':
    case '@schedule/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.saving = false;
      });

    case '@schedule/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@schedule/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.registry = action.payload.data;
      });

    case '@schedule/INDEX_FAILURE':
    case '@schedule/CREATE_FAILURE':
    case '@schedule/UPDATE_FAILURE':
    case '@schedule/DELETE_FAILURE':
      return produce(state, draft => {
        draft.saving = false;
        draft.error = true;
      });

    case '@schedule/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    default:
      return state;
  }
}
